const FILTER_ADMIN_HTML_BASE_URL =
  process.env.REACT_APP_FILTER_ADMIN_HTML_BASE_URL || 'http://localhost:3000';

var config = {
  app: {
    name: process.env.REACT_APP_SHOPIFY_APP_NAME,
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    appScope: [
      'read_products',
      'read_orders',
      'read_themes',
      'read_content',
      'write_themes',
      'read_locales',
      'read_translations',
      'read_locations',
      'read_inventory',
      // b2b
      'read_customers',
      'read_markets',
      // storefront api
      'unauthenticated_read_product_inventory',
      'unauthenticated_read_product_listings',
      // new access scopes (for recommendation)
      'read_all_orders',

      // new access scopes (for bundle)
      'read_discounts',
      'write_discounts',
      // access scopes for pre-order
      'write_purchase_options',
      'write_products',
      'write_orders', // access scopes for update pre-order tag
      // access scope to sync data for product field published_scope in graphql
      'read_publications',
      'read_shipping',

      // metaobjects
      'read_metaobjects',
      'read_metaobject_definitions'
    ].join(', '),
    nonce: 'bcfilter@2016',
    installCallbackUrl: `${FILTER_ADMIN_HTML_BASE_URL}/oauth/finalize`,
    updatePermissionCallbacklUrl: `${FILTER_ADMIN_HTML_BASE_URL}/update-permission-success`
  },
  api: {
    adminURL: process.env.REACT_APP_ADMIN_V2_BASE_URL,
    syncURL: process.env.REACT_APP_SYNC_V2_BASE_URL
  },
  site: {
    syncStatusTimeout: 5000,
    lastSyncTimeout: 180000, // 3 mins
    showSyncProgressTimeout: 10000
  },
  integrations: {
    fullStory: {
      orgId: process.env.REACT_APP_FULLSTORY_ORG_ID,
      debug: process.env.NODE_ENV !== 'production',
      devMode: process.env.NODE_ENV !== 'production'
    }
  }
};

module.exports = config;
